<template>
  <div>
    <DormList :dorms="dorms" v-if="dorms.length > 0" />
    <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
    <FixedPopup
      :dorms="popupDorms"
      v-if="popupDorms && popupDorms.length > 0"
    />
  </div>
</template>

<script>
import DormList from '@/components/DormList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
export default {
  name: 'Dorms',
  components: {
    DormList,
    InfiniteLoading,
    FixedPopup
  },
  data() {
    return {
      page: 2,
      dorms: [],
      pagination: null,
      popupDorms: null,
      emptyContent: {
        icon: 'icon-search',
        title: 'Sonuç Bulunamadı!',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      }
    }
  },
  methods: {
    infiniteHandler($state) {
      let self = this

      console.log('route::', this.$route)
      let url = 'site/dorm-list-all'
      if (this.$route.params.slug) {
        url += `/${this.$route.params.slug}`
      }
      axios.get(`${url}?page=${this.page}`).then(response => {
        if (response.data.data.data) {
          this.page += 1
          // this.$router.replace('Page=' + this.page, { silent: true })
          if (
            Array.isArray(self.dorms) &&
            Array.isArray(response.data.data.data) !== true &&
            Object.keys(response.data.data.data).length !== 0
          ) {
            Object.keys(response.data.data.data).forEach(item => {
              self.dorms.push(response.data.data.data[item])
            })
            console.log('dormsss:::', response.data)
            self.popupDorms = response.data.data.popups
            $state.loaded()
          } else {
            $state.complete()
          }
        }
      })
    },
    getAllDorms() {
      // const page = this.$route.params.page ? this.$route.params.page : 1
      let self = this
      axios
        .get(`/site/dorm-list-all/`)
        .then(response => {
          console.log('res::', response)
          response.data.forEach(function(element) {
            self.dorms.push(element.dorm)
          })
        })
        .catch(e => {
          self.errors.push(e)
        })
    }
  },
  created() {
    this.getAllDorms()
  }
}
</script>

<style scoped></style>
